import apiRoutes from '../helpers/apiRoutes';
import { get, post } from '../libs/api/apiConnector';

export const getLicenseRecords = async body => {
  try {
    const url = apiRoutes.CANNABIS_LICENSES.GET_LICENCES;
    const { data } = await post(url, body);
    return data;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(`error ${error}`);
    throw error;
  }
};

export const getLicenseDetails = async id => {
  try {
    const url = `${apiRoutes.CANNABIS_LICENSES.GET_LICENCES}/${id}`;
    const { data } = await get(url);
    return data;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(`error ${error}`);
    throw error;
  }
};

export const createCannbisLicense = async body => {
  try {
    const url = apiRoutes.CANNABIS_LICENSES.CREATE_LICENCES;
    const { data } = await post(url, body);
    return data;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(`error ${error}`);
    throw error;
  }
};
